module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/hvz/ortho-field-config-translation.json
// module id = 1237
// module chunks = 0